import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardRepostEventRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardRepostEventPageContainerLoadable } from './OrgDashboardRepostEventPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardRepostEventRoute>,
) {
  await OrgDashboardRepostEventPageContainerLoadable.load();
}

export default function OrgDashboardRepostEventHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardRepostEventPageContainerLoadable />;
}
